import React from "react";
import { PRIMARY_COLOR } from "../assets/style/colors";

const SubmitButton = ({ onClick, title = "Submit", disabled, isFormValid, loading, style }) => {

    return (
        <button
            disabled={disabled}
            type="button"
            style={{
                backgroundColor: isFormValid || disabled
                    ? "#7ea1b8cc"
                    : PRIMARY_COLOR,
                cursor: disabled ? "not-allowed" : "pointer",
                // opacity: disabled ? 0.6 : 1,
                ...style
            }}
            className="add-button  f2 fs-xl-16 fs-xxl-18"
            onClick={onClick}
        >
            {loading ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                    ></span>
                </>
            ) : (
                title
            )}
        </button>
    )
}
export default SubmitButton;
